import classNames from "classnames";
import PropTypes from "prop-types";

import { ModalDialog } from "@openedx/paragon";
import { useIntl } from "@edx/frontend-platform/i18n";
import { ActionRow, Button } from "@openedx/paragon";

import messages from "./messages";
import { nullMethod } from "./hooks";
import useDeleteCourse from "./hooks";

export const DeleteCourseConfirmationModal = ({
  closeModal,
  show,
  courseId,
  courseName,
}) => {
  const { handleConfirm, handleClose } = useDeleteCourse({
    closeModal,
    courseId,
  });
  const { formatMessage } = useIntl();
  const showFullscreen = false;
  return (
    <ModalDialog
      isOpen={show}
      onClose={nullMethod}
      hasCloseButton={false}
      isFullscreenOnMobile={showFullscreen}
      title="Delete Course"
    >
      <div
        className={classNames("bg-white p-3 rounded", {
          shadow: !showFullscreen,
        })}
        style={{ textAlign: "start" }}
      >
        <h4>{formatMessage(messages.confirmHeader) + courseName + "?"}</h4>
        <ActionRow>
          <Button variant="tertiary" onClick={handleClose}>
            {formatMessage(messages.confirmCancel)}
          </Button>
          <Button onClick={handleConfirm}>
            {formatMessage(messages.confirmDelete)}
          </Button>
        </ActionRow>
      </div>
    </ModalDialog>
  );
};

DeleteCourseConfirmationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  courseId: PropTypes.string.isRequired,
  courseName: PropTypes.string.isRequired,
};

export default DeleteCourseConfirmationModal;
